import { administrators } from 'constants/auth';
import IndexCategoryType from 'pages/Administration/Category/index';
import Users from 'pages/Administration/Users';
import React from 'react';
import { MdDone } from 'react-icons/md';
import { ROLES } from 'utils/authorization';

export default [
  {
    path: '/admin/users',
    name: 'Quản lý người dùng',
    miniName: 'C',
    icon: 'ni ni-ungroup',
    component: Users,
    layout: '/lms',
    exact: true,
    roles: ['administrator'],
    users: administrators,
    showInSidebar: true,
    sortOrder: 3,
    type: ['administrationRouters'],
  },

  // {
  //   path: '/admin/classes',
  //   name: 'Quản lý lớp học',
  //   miniName: 'C',
  //   icon: 'ni ni-ungroup',
  //   component: React.lazy(() => import('pages/Administration/Classes')),
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 3,
  //   type: ['administrationRouters'],
  // },
  // Tạm ẩn vì xử lý chứng danh mục kỹ năng theo khối lớp
  // {
  //   path: '/admin/skills',
  //   name: 'Quản lý kỹ năng',
  //   miniName: 'C',
  //   icon: <GiSkills />,
  //   component: React.lazy(() => import('pages/Administration/Skill')),
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 4,
  //   type: ['administrationRouters'],
  // },

  // {
  //   path: '/admin/quiz',
  //   name: 'Quiz',
  //   miniName: 'Q',
  //   icon: 'ni ni-ungroup',
  //   component: OneChoice_Update,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 7,
  //   type: ['administrationRouters'],
  // },
  // {
  //   collapse: true,
  //   name: 'Olympic (Admin)',
  //   icon: <FaUser className='tw-text-purple-600' size={16} />,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 4,
  //   state: 'olympic/admin',
  //   type: ['administrationRouters'],
  //   views: [
  //     {
  //       path: '/olympic/admin/questions/class/:ClassName/types/:type',
  //       component: ViewQuestions,
  //       layout: '/lms',
  //       exact: true,
  //       roles: ['administrator'],
  //       users: administrators,
  //     },
  //     {
  //       path: '/olympic/admin/questions/class/',
  //       name: 'Question types (All)',
  //       miniName: 'T',
  //       component: Olympic_ViewQuestions,
  //       layout: '/lms',
  //       exact: true,
  //       roles: ['administrator'],
  //       users: administrators,
  //       showInSidebar: true,
  //       sortOrder: 0,
  //     },
  //     {
  //       path: '/olympic/admin',
  //       name: 'Question types (Class)',
  //       miniName: 'O',
  //       component: Olympic_Admin,
  //       layout: '/lms',
  //       exact: false,
  //       roles: ['administrator'],
  //       users: administrators,
  //       showInSidebar: true,
  //       sortOrder: 0,
  //     },
  //   ],
  // },
  {
    path: '/admin/document-library',
    name: 'Thư viện',
    miniName: 'C',
    icon: 'fas fa-book text-blue',
    component: React.lazy(() => import('pages/DocumentLibrary/DocumentLibrary')),
    layout: '/lms',
    exact: true,
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER, ROLES.TESTBANK],
    type: ['administrationRouters'],
    showInSidebar: true,
    sortOrder: 0,
    strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com', 'trangnhd@phuongnam.edu.vn', 'trinm@phuongnam.edu.vn'],
  },
  {
    path: '/admin/import-question',
    name: 'Quản lý câu hỏi',
    miniName: 'C',
    icon: 'fas fa-question',
    component: React.lazy(() => import('pages/Administration/ImportQuestion')),
    layout: '/lms',
    exact: true,
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER, ROLES.TESTBANK],
    type: ['administrationRouters'],
    showInSidebar: true,
    sortOrder: 1,
    strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com', 'trangnhd@phuongnam.edu.vn', 'trinm@phuongnam.edu.vn'],
  },
  {
    path: '/admin/test-bank',
    name: 'Ngân hàng đề kiểm tra',
    miniName: 'C',
    icon: <MdDone size={20} className='tw-text-green-600' />,
    component: React.lazy(() => import('pages/TestBank/TestBank')),
    layout: '/lms',
    exact: true,
    roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER, ROLES.TESTBANK],
    type: ['administrationRouters'],
    showInSidebar: true,
    sortOrder: 2,
    strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com', 'trangnhd@phuongnam.edu.vn', 'trinm@phuongnam.edu.vn'],
  },

  {
    path: '/admin/quan-ly-type-optiontype',
    name: 'Type & OptionType',
    miniName: 'C',
    icon: '	fas fa-cogs',
    component: IndexCategoryType,
    layout: '/lms',
    exact: true,
    roles: ['administrator', ROLES.TESTBANK],
    type: ['administrationRouters'],
    showInSidebar: true,
    sortOrder: 3,
    strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com', 'trangnhd@phuongnam.edu.vn', 'trinm@phuongnam.edu.vn'],
  },
  // {
  //   path: '/ai/pronunciation-assessment',
  //   name: 'Pronunciation assessment',
  //   miniName: 'P',
  //   icon: <FaRobot className='tw-text-yellow-600' size={16} />,
  //   component: PronunciationAssessment,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 5,
  //   type: ['administrationRouters'],
  // },
  // {
  //   path: '/ai/speech-to-text',
  //   name: 'Speech to Text',
  //   miniName: 'P',
  //   icon: <FaRobot className='tw-text-red-600' size={16} />,
  //   component: SpeechToText,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 6,
  //   type: ['administrationRouters'],
  // },
];
